var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLevel10Bg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 575,
    height: 250,
    viewBox: "0 0 575 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_485_37953)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M-2.67029e-05 -3L-32 29",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M0 -3L32 29",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.89,
    d: "M64 -3L32 29",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M63.998 -3L95.998 29",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.63,
    d: "M128 -3L96 29",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M160 -3L128 29",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.96,
    d: "M160 -3L192 29",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.28,
    d: "M192 -3L224 29",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M224 -3L256 29",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M256 -3L288 29",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M288 -3L320 29",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M320 -3L352 29",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M351.998 -3L383.998 29",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M384 -3L416 29",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M416 -3L448 29",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M448 -3L480 29",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M479.998 -3L511.998 29",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.59,
    d: "M512 -3L544 29",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.97,
    d: "M576 -3L544 29",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.14,
    d: "M608 -3L576 29",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M-2.67029e-05 29L-32 61",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.71,
    d: "M0 29L32 61",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.14,
    d: "M32 29L64 61",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M63.998 29L95.998 61",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.52,
    d: "M96 29L128 61",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M128 29L160 61",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.54,
    d: "M192 29L160 61",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M224 29L192 61",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M224 29L256 61",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.78,
    d: "M256 29L288 61",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.26,
    d: "M288 29L320 61",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.91,
    d: "M352 29L320 61",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.63,
    d: "M351.998 29L383.998 61",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.52,
    d: "M416 29L384 61",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M416 29L448 61",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.78,
    d: "M448 29L480 61",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.83,
    d: "M479.998 29L511.998 61",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.66,
    d: "M512 29L544 61",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.51,
    d: "M544 29L576 61",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M608 29L576 61",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.62,
    d: "M-2.67029e-05 61L-32 93",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.94,
    d: "M0 61L32 93",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M64 61L32 93",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.95,
    d: "M95.998 61L63.998 93",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M96 61L128 93",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M160 61L128 93",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M160 61L192 93",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.83,
    d: "M192 61L224 93",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.92,
    d: "M224 61L256 93",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.32,
    d: "M288 61L256 93",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.67,
    d: "M288 61L320 93",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M320 61L352 93",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.57,
    d: "M351.998 61L383.998 93",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M384 61L416 93",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.32,
    d: "M448 61L416 93",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M448 61L480 93",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.37,
    d: "M479.998 61L511.998 93",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M512 61L544 93",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M576 61L544 93",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.57,
    d: "M608 61L576 93",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M-32 93L-2.67029e-05 125",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.72,
    d: "M0 93L32 125",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.63,
    d: "M32 93L64 125",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.83,
    d: "M63.998 93L95.998 125",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M96 93L128 125",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.95,
    d: "M128 93L160 125",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M192 93L160 125",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.86,
    d: "M192 93L224 125",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.63,
    d: "M224 93L256 125",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M256 93L288 125",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M288 93L320 125",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M320 93L352 125",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M383.998 93L351.998 125",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.91,
    d: "M416 93L384 125",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.37,
    d: "M448 93L416 125",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.63,
    d: "M448 93L480 125",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M511.998 93L479.998 125",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.77,
    d: "M512 93L544 125",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M544 93L576 125",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M576 93L608 125",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M-2.67029e-05 125L-32 157",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.69,
    d: "M0 125L32 157",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M32 125L64 157",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.86,
    d: "M63.998 125L95.998 157",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.67,
    d: "M96 125L128 157",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128 125L160 157",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M160 125L192 157",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.62,
    d: "M224 125L192 157",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.14,
    d: "M224 125L256 157",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M256 125L288 157",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.88,
    d: "M320 125L288 157",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.72,
    d: "M320 125L352 157",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M351.998 125L383.998 157",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.61,
    d: "M384 125L416 157",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.77,
    d: "M416 125L448 157",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M448 125L480 157",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M511.998 125L479.998 157",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M544 125L512 157",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M544 125L576 157",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M576 125L608 157",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.91,
    d: "M-32 157L-2.67029e-05 189",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M0 157L32 189",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.63,
    d: "M32 157L64 189",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M95.998 157L63.998 189",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    d: "M96 157L128 189",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M128 157L160 189",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.14,
    d: "M160 157L192 189",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.68,
    d: "M192 157L224 189",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.62,
    d: "M224 157L256 189",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M288 157L256 189",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.99,
    d: "M288 157L320 189",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.99,
    d: "M320 157L352 189",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M383.998 157L351.998 189",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.88,
    d: "M384 157L416 189",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M416 157L448 189",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "M448 157L480 189",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.66,
    d: "M479.998 157L511.998 189",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M512 157L544 189",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.56,
    d: "M544 157L576 189",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M576 157L608 189",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M-32 189L-2.67029e-05 221",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M0 189L32 221",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M32 189L64 221",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M63.998 189L95.998 221",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M96 189L128 221",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M128 189L160 221",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.37,
    d: "M160 189L192 221",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.91,
    d: "M224 189L192 221",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M224 189L256 221",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M256 189L288 221",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M288 189L320 221",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M320 189L352 221",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.32,
    d: "M351.998 189L383.998 221",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.53,
    d: "M384 189L416 221",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M416 189L448 221",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M448 189L480 221",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M479.998 189L511.998 221",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.52,
    d: "M512 189L544 221",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M544 189L576 221",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.73,
    d: "M608 189L576 221",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M-32 221L-2.67029e-05 253",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.68,
    d: "M0 221L32 253",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.97,
    d: "M64 221L32 253",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.93,
    d: "M95.998 221L63.998 253",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M128 221L96 253",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M128 221L160 253",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M160 221L192 253",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.89,
    d: "M224 221L192 253",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.94,
    d: "M224 221L256 253",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M256 221L288 253",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M288 221L320 253",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M352 221L320 253",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.99,
    d: "M351.998 221L383.998 253",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.74,
    d: "M384 221L416 253",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M448 221L416 253",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M448 221L480 253",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.73,
    d: "M479.998 221L511.998 253",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M544 221L512 253",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M544 221L576 253",
    stroke: "#FFE500",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "M576 221L608 253",
    stroke: "#FFE500",
    strokeWidth: 4
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_485_37953"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H525C552.614 0 575 22.3858 575 50V200C575 227.614 552.614 250 525 250H0V0Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevel10Bg);
export default __webpack_public_path__ + "static/media/level10-bg.653e984f5cef87a38f2dd1fd41ff5105.svg";
export { ForwardRef as ReactComponent };